import { Box, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

interface NoSegmentMatchProps {
  searchTerm: string;
}

export default function NoSegmentMatch({ searchTerm }: NoSegmentMatchProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 2,
        padding: 3,
      }}
    >
      <SearchOffIcon
        sx={{
          fontSize: 48,
          color: "text.disabled",
          opacity: 0.5,
        }}
      />
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h6"
          sx={{
            color: "text.secondary",
            fontWeight: 400,
            mb: 1,
          }}
        >
          No segments found
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.disabled",
            maxWidth: 300,
          }}
        >
          No segments match &ldquo;{searchTerm}&rdquo;. Try searching with different keywords.
        </Typography>
      </Box>
    </Box>
  );
}